import { Badge, BadgeProps } from "@mantine/core"
import { ReactNode } from "react"

type Props = {
  /** The code/identifier to render (SO-XXXX, PO-XXXX, DN-XXXX, etc.) */
  children?: ReactNode
  /** Explicit placeholder when children is falsy (defaults to "-") */
  placeholder?: string
  size?: BadgeProps["size"]
  radius?: BadgeProps["radius"]
  /** Outlined (default), white "default" or gray-filled "light" (canvas Ord_ShipDetail) */
  variant?: "outline" | "default" | "light"
  color?: BadgeProps["color"]
}

/**
 * Compact pill for displaying an SO/PO/DN code inside tables and sidebars.
 * Renders an outlined Badge with the label `overflow: visible` so wider
 * codes don't get clipped the way Mantine's default does.
 */
export function CodeBadge({
  children,
  placeholder = "-",
  size = "md",
  radius = "sm",
  variant = "outline",
  color = "gray",
}: Props) {
  return (
    <Badge
      size={size}
      radius={radius}
      variant={variant}
      color={color}
      styles={{ label: { overflow: "visible" } }}
    >
      {children || placeholder}
    </Badge>
  )
}
